<template>
    <div class="demo-wrapper">

      <transition name="fade" mode="out-in">
        <router-view :isPortrait="isPortrait"></router-view>
      </transition>

      <noise />

      <div class="demo-controller d-flex justify-content-center" ref="controls">
        <div class="wrapper demos d-flex align-items-stretch">
          <template v-for="(btn, index) in buttons">
            <demo-button
              class="ani"
              :key="btn.idx"
              :idx="btn.idx"
              :icon="btn.icon"
              :namespace="btn.namespace"
              :ref="btn.namespace"
              @click.native="buttonHandler(btn.idx, btn.url, btn.namespace)"/>

              <div class="chevron d-flex align-items-center ani" v-if="index < buttons.length - 1">
                <chevron />
              </div>
            </template>
          </div>
          <div class="wrapper report d-flex align-items-stretch">
            <demo-button class="ani" :icon="reportIcon" @click.native="buttonHandler(4, '/report')"/>
          </div>
      </div>

      <landscape-message />

    </div>
</template>

<script>
// import { mapState } from 'vuex'
import { TweenMax, Elastic, Power2 } from 'gsap'
import DemoButton from './DemoButton'
import Noise from './Noise'
import LandscapeMessage from '@/components/LandscapeMessage'
import Chevron from '@/components/svg/Chevron'
import ScrollIcon from '@/components/svg/ScrollIcon'
import MotionIcon from '@/components/svg/MotionIcon'
import ArIcon from '@/components/svg/ArIcon'
import ReportIcon from '@/components/svg/ReportIcon'

export default {
  name: 'demo-controller',
  components: {
    LandscapeMessage,
    Chevron,
    DemoButton,
    Noise
  },
  data () {
    return {
      isPortrait: true,
      didShowControls: false,
      buttons: [{
        idx: 1,
        namespace: 'demo1',
        url: 'motion',
        icon: MotionIcon
      },
      {
        idx: 2,
        namespace: 'demo2',
        url: 'scroll',
        icon: ScrollIcon
      },
      {
        idx: 3,
        namespace: 'demo3',
        url: 'terrain',
        icon: ArIcon
      }]
    }
  },
  computed: {
    reportIcon () {
      return ReportIcon
    }
  },
  methods: {
    onOrientationChange () {
      let orientation = 0
      if ( 'orientation' in window ) {
        orientation = window.orientation
      } else if ( 'screen' in window ) {
        orientation = window.screen.orientation.angle
      }

      if ( orientation % 180 !== 0 ) {
        this.isPortrait = false
      } else {
        this.isPortrait = true
      }
    },
    buttonHandler ( idx, url, namespace ) {
      switch (idx) {
        case 4:
          this.$router.push( { path: url } )
          break
        default:
          if ( this.$refs[namespace][0].enabled ) {
            this.$router.push( { name: url } )
          }
          break
      }
    },
    showControls () {
      if ( !this.didShowControls ) {
        TweenMax.to( '.demo-controller .wrapper', 1, {
          y: 0,
          ease: Power2.easeOut
        })
        TweenMax.staggerTo( '.ani', 1, {
          y: 0,
          delay: 0.25,
          ease: Elastic.easeOut.config( 0.25 )
        }, 0.075)
        this.didShowControls = true
      }
    }
  },
  created () {
    window.addEventListener( 'orientationchange', this.onOrientationChange )
  },
  mounted () {
    TweenMax.set( '.ani', { y: 60 } )
    TweenMax.set( '.demo-controller .wrapper', { y: 100 } )
    this.$nextTick(() => {
      if ( window.innerWidth > window.innerHeight ) {
        this.onOrientationChange()
      }

      if ( this.$store.state.report.didView ) {
        this.showControls()
      }
    })
  },
  beforeDestroy () {
    TweenMax.killTweensOf( [ this.$refs.controls, this.$refs.controls.children, '.demo-wrapper' ] )
    window.removeEventListener( 'orientationchange', this.onOrientationChange )
  },
  beforeRouteEnter ( to, from, next ) {
    next( vm => {
      TweenMax.fromTo( '.demo-wrapper', 2, { opacity: 0 }, { opacity: 1 } )
    } )
  },
  beforeRouteLeave ( to, from, next ) {
    TweenMax.to( '.demo-wrapper', 0.3, { opacity: 0, onComplete: next } )
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/global/the_goods";

.demo-wrapper {
  position    : absolute;
  top         : 0;
  left        : 0;
  width       : 100%;
  height      : 100%;
  overflow    : hidden;

  .demo-controller {
    position  : absolute;
    left      : 0;
    right     : 0;
    bottom    : 0;
    height    : 60px;
    margin    : 20px 30px;
    z-index   : 15;
    overflow  : hidden;

    .wrapper {
      background    : rgba(255, 255, 255, 1);
      border-radius : 30px;

      &.demos {
        max-width     : 360px;
        flex-grow     : 1;
        margin-right  : 10px;
      }

      &.report {
        width         : 60px;
        padding-right : 2px;
      }
    }

    .chevron {
      width : 6px;

      svg {
        width : 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/demos/DemoController.vue